import type { CatalogEvent, CatalogMatchDetail, CatalogPlayer } from "@livcg/schema";
import { coachSide } from "@livcg/schema";

/** The "Bekor qilindi" banner for a yellow being deleted from the event log —
 *  the same shape as the QuickEvents card payload. */
export function yellowCancelBanner(
  ev: CatalogEvent,
  detail: CatalogMatchDetail | null,
  coach?: (side: "home" | "away") => CatalogPlayer,
): { mode: string; data: { playerNumber: number | string; playerName: string } } | null {
  if (ev.type !== "yellow_card" || !detail) return null;
  const side =
    detail.home.team.id === ev.teamId ? "home" : detail.away.team.id === ev.teamId ? "away" : null;
  if (!side) return null;
  const isCoach = !!coach && coachSide(ev.playerId) === side;
  const player = isCoach ? coach(side) : detail[side].players.find((p) => p.id === ev.playerId);
  if (!player) return null;
  return {
    mode: `little_card_yellowcancel_${side}`,
    data: {
      playerNumber: player.number ?? (isCoach ? "" : 0),
      playerName: player.lastName || player.firstName,
    },
  };
}
